import React from 'react';
import platform from 'platform';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { observer } from 'mobx-react';
import { action, extendObservable } from 'mobx';
import Password from '../../_shared/Fields/Password';
import Username from '../../_shared/Fields/Username';
import * as validate from '../../../helpers/formValidation';
import store from '../../../stores/store';
import bannerImage from '../../../assets/images/promo-banner.png';
import {
    DEFAULT_ERROR_MSG,
    ELECTRON_LOGIN_USER_OFFLINE_MESSAGE,
    TCS_TITLE,
    TCS_MSG,
    TCS_BUTTON,
} from '../../../helpers/messageText';
import { WINDOWS_EXE_ELECTRON_LINK, MAC_DMG_ELECTRON_LINK } from '../../../helpers/api';
//import { createDiffieHellman } from 'crypto';
let app;
if (window.require) {
    app = window.require('electron').remote.app;
}

const SignInForm = observer(
    class SignInForm extends React.Component {
        constructor(props) {
            super(props);
            // magic and here
            // better to mutate data which observable by actions!
            this.form = extendObservable(this, {
                username: '',
                usernameFieldState: true,
                password: '',
                passwordFieldState: true,
                termsCheck: false,
                captchaIn: false,
                error: '',
                pending: false,

                set: action((field, value) => {
                    this[field] = value;
                }),
                get canSubmitForm() {
                    let cookie = this.getCookie('NoCaptchaCookie');

                    if (cookie) {
                        return (
                            this.passwordFieldState &&
                            this.usernameFieldState &&
                            this.username &&
                            this.password &&
                            this.termsCheck
                        );
                    } else {
                        return (
                            this.passwordFieldState &&
                            this.usernameFieldState &&
                            this.username &&
                            this.password &&
                            this.termsCheck &&
                            this.captchaIn
                        );
                    }
                },
            });

            this.state = {
                shouldShowDownloadLink: true,
                captcha: '',
            };
        }

        componentWillMount() {
            if (window.offlineApiExtension) {
                this.isRefreshTokenAndHashedPinExist().then(pinExists => {
                    if (pinExists) {
                        store.user.setLoggedIn(true);
                        store.user.setPinExists(true);
                        this.props.history.push('/pin');
                    }
                });
            }

            store.user.getCaptcha().then(res => {
                this.setState({
                    captcha: res,
                });
            });

            this.resetErrorMessage();
        }

        resetErrorMessage = () => {
            const message = this.props.location.search.substring(1);
            if (message !== undefined && message.length > 0) {
                this.form.set('error', unescape(message));
            } else {
                this.form.set('error', '');
            }
        };

        handleSubmit = event => {
            event.preventDefault();
            if (
                window.offlineApiExtension &&
                window.require &&
                !store.conn.isOnline
                // !window.offlineApiExtension.isOnline()
            ) {
                this.form.set('error', ELECTRON_LOGIN_USER_OFFLINE_MESSAGE);
                return;
            }

            let cookie = this.getCookie('NoCaptchaCookie');

            if (
                cookie === '' &&
                (this.state.captcha.Details === null ||
                    this.state.captcha.Details.ImageText !== this.form.captcha)
            ) {
                store.user.getCaptcha().then(res => {
                    this.setState({
                        captcha: res,
                    });
                });
                this.form.set('error', 'Verification code is incorrect');
                return;
            }

            const credentials = {
                username: this.form.username,
                password: this.form.password,
            };
            this.form.set('pending', true);
            store.user
                .login(credentials)
                .then(e => {
                    if (e.error) {
                    } else if (this.form.cookieChecked === true) {
                        var d = new Date();
                        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
                        var expires = 'expires=' + d.toUTCString();
                        document.cookie = 'NoCaptchaCookie=Yes;' + expires + ';path=/';
                    }

                    if (window.offlineApiExtension) {
                        if (window.offlineApiExtension) {
                            if (e.error) {
                                this.props.history.push('/error');
                            } else {
                                store.user.getValueFromActorStorage('hashedPin').then(pinExists => {
                                    this.props.history.push('/pin');
                                });
                            }
                        }
                    }
                })
                .catch(e => {
                    this.form.set('pending', false);

                    if (
                        e !== undefined &&
                        e.spread !== undefined &&
                        (e.spread.error_description !== undefined || e.message !== undefined)
                    ) {
                        this.form.set('error', e.spread.error_description || e.message);
                    } else {
                        this.form.set('error', DEFAULT_ERROR_MSG);
                    }
                });
        };

        handleProceed = async event => {
            // let ret = await store.user.changeAppUser();
            await store.user.changeAppUser();
            this.props.history.push('/pin');
        };

        async isRefreshTokenAndHashedPinExist() {
            let hashedPin = store.user.getValueFromActorStorage('hashedPin');
            let refreshToken = store.user.getValueFromActorStorage('refreshToken');
            return hashedPin && refreshToken;
        }

        handleChange = e => {
            switch (e.target.name) {
                case 'password':
                    // Password - Mandatory, 8-50 chars, at least 1 Uppercase, 1 Lowercase, 1 Number and 1 Special Character
                    let errPwdCount = validate.password(e.target.value);
                    this.resetErrorMessage();
                    this.form.set('passwordFieldState', errPwdCount === 0);
                    this.form.set('password', e.target.value);
                    break;

                case 'username':
                    // Username - Mandatory, 5-50 chars, alphanumeric, no spaces
                    let errCount = validate.required(e.target.value);
                    errCount += validate.length(e.target.value, 5, 50);
                    errCount += validate.alphanumeric(e.target.value);
                    //   console.log('SignInForm handleChange', errCount);
                    this.form.set('usernameFieldState', errCount === 0);
                    this.form.set('username', e.target.value);
                    this.resetErrorMessage();
                    break;

                case 'termsCheck':
                    // Terms and Conditions - must be checked
                    this.form.set('termsCheck', e.target.checked);
                    break;

                case 'cookieCheck':
                    this.form.set('cookieChecked', e.target.checked);
                    break;

                case 'captcha':
                    this.form.set('captcha', e.target.value);
                    //console.log("captc target value: ", e.target.value)
                    this.form.set('captchaIn', e.target.value !== '');
                    break;

                default:
                    break;
            }
        };

        onRegisterHandler = () => {
            this.props.history.push('/register');
        };

        onForgottenHandler = () => {
            this.props.history.push('/forgotten');
        };

        printTermsAndConditions = () => {
            // store.alert.hideAlert();
            // const printDivCSS = new String ('<link href="myprintstyle.css" rel="stylesheet" type="text/css">')
            // window.frames["print_frame"].document.body.innerHTML=printDivCSS + document.getElementById(divId).innerHTML;
            window.frames['print_frame'].document.body.innerHTML = document.getElementById(
                'termsModal',
            ).innerHTML;
            window.frames['print_frame'].window.focus();
            window.frames['print_frame'].window.print();
        };

        getCookie = cname => {
            var name = cname + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };

        signForm = () => {
            const Example = ({ data }) => (
                <img
                    alt="logo"
                    src={`data:image/jpg;base64,${data}`}
                    style={{ paddingLeft: '127px' }}
                />
            );
            const displayDownloadPerOS =
                (platform.os.family.includes('Windows') &&
                    !platform.os.family.includes('Windows Phone')) ||
                platform.os.family === 'OS X';
            const cookie = this.getCookie('NoCaptchaCookie');
            if (store.user.newUserTryingToLogin && window.offlineApiExtension) {
                return (
                    <div>
                        <div className="mt-3">
                            <legend>
                                <span className="legend-border-bottom">Sign in</span>
                            </legend>                         
                            <hr />
                            <div className="alert alert-info animated fadeIn" role="alert">
                                <strong>Signing in will erase the previous user's PIN.</strong>{' '}
                                <br /> Do you wish to proceed?
                            </div>
                            <div className="d-flex justify-content-end mb-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary mr-3"
                                    onClick={() => {
                                        store.user.logout();
                                    }}
                                >
                                    No
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        this.handleProceed();
                                    }}
                                >
                                    Yes, proceed
                                </button>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div>
                        <div className="text-center">
                            <a href="https://www.boardtrac.com.au/contact/" target="_blank">
                                <img className="mt-4 mb-4" alt="promotional-banner" src={bannerImage} />
                            </a>
                        </div>

                        <div className="mt-3">
                            {this.form.error && (
                                <div className="alert alert-danger mt-4" role="alert">
                                    {this.form.error}
                                </div>
                            )}
                            <form className="position-relative" onSubmit={this.handleSubmit}>
                                <legend>
                                    <span className="legend-border-bottom">Sign in</span>
                                </legend>
                                <a onClick={this.onForgottenHandler} className="btn btn-outline-primary forgot-link" >
                                    Forgot sign in details?
                                 </a>
                                <hr />

                                <Username
                                    handleChange={this.handleChange}
                                    fieldState={this.form.usernameFieldState}
                                    defaultValue={this.form.username}
                                />
                                <Password
                                    handleChange={this.handleChange}
                                    fieldState={this.form.passwordFieldState}
                                    defaultValue={this.form.password}
                                />

                                {cookie === '' &&
                                    this.state.captcha.Details !== null &&
                                    this.state.captcha.Details !== undefined && (
                                        <div>
                                            <div className="form-group row">
                                                <Example data={this.state.captcha.Details.Image} />
                                            </div>
                                            <div
                                                className="form-group row"
                                                style={{ 'margin-bottom': '0px' }}
                                            >
                                                <label className="col-2 col-form-label">
                                                    Verification
                                                </label>

                                                <div className="col-sm-10">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            name="captcha"
                                                            onChange={this.handleChange}
                                                            className="form-control"
                                                            placeholder=""
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className="form-group row"
                                                    style={{
                                                        'margin-bottom': '17px',
                                                        'margin-top': '25px',
                                                    }}
                                                >
                                                    <div className="col-sm-10 offset-md-2">
                                                        {!window.offlineApiExtension && (
                                                            <label
                                                                className="form-check-label"
                                                                style={{
                                                                    'padding-left': '2.55rem',
                                                                }}
                                                            >
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    name="cookieCheck"
                                                                    onClick={this.handleChange}
                                                                />
                                                                &nbsp;Remember this device. Please
                                                                do no select if you are on a shared
                                                                or public computer
                                                            </label>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                <div className="form-group row">
                                    <div className="col-sm-10 offset-md-2">
                                        <label className="form-check-label">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name="termsCheck"
                                                onClick={this.handleChange}
                                            />{' '}
                                            I have read and agree to the
                                        </label>{' '}
                                        <span
                                            className="terms_and_conditions btn-outline-primary mb-2 cursor-pointer"
                                            onClick={() =>
                                                store.alert.setAlert(
                                                    store.alert.hideAlert,
                                                    this.printTermsAndConditions,
                                                    TCS_TITLE,
                                                    TCS_MSG,
                                                    'Close',
                                                    TCS_BUTTON,
                                                )
                                            }
                                            data-toggle="modal"
                                            data-target="#termsModal"
                                        >
                                            terms and conditions
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-10 offset-sm-2">
                                        <LaddaButton
                                            className="btn btn-primary btn-block"
                                            loading={this.form.pending}
                                            onClick={this.handleSubmit}
                                            disabled={!this.form.canSubmitForm}
                                            data-size={S}
                                            data-style={SLIDE_LEFT}
                                            data-spinner-size={30}
                                            data-spinner-color="#fff"
                                            data-spinner-lines={12}
                                        >
                                            Sign in
                                        </LaddaButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {window.require && (
                            <div className="">
                                <hr />
                                <div className="pl-3 pr-1 pb-2 pull-right">                                                            
                                        <div className="text-right version">
                                            Version: {app.getVersion()}
                                        </div>                               
                                </div>
                            </div>
                         )}
                        {!window.offlineApiExtension &&
                            this.state.shouldShowDownloadLink &&
                            displayDownloadPerOS && (
                                <div className="footer animated slideInUp">
                                    <div
                                        className="alert alert-primary alert-dismissible show open-in-app"
                                        role="alert"
                                    >
                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="alert"
                                            aria-label="Close"
                                            onClick={() => {
                                                this.setState({
                                                    shouldShowDownloadLink: false,
                                                });
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <span className="mr-2">Download desktop app for</span>
                                        <div className="electron-download-btn-grp">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary mr-2"
                                                onClick={() => {
                                                    window.open(WINDOWS_EXE_ELECTRON_LINK);
                                                }}
                                            >
                                                <i
                                                    className="fa fa-windows mr-1"
                                                    aria-hidden="true"
                                                />{' '}
                                                Windows
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={() => {
                                                    window.open(MAC_DMG_ELECTRON_LINK);
                                                }}
                                            >
                                                <i
                                                    className="fa fa-apple mr-1"
                                                    aria-hidden="true"
                                                />{' '}
                                                Mac
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                );
            }
        };

        downloadExeFile(flag) {
            if (flag) {
            }
        }

        render() {
            return this.signForm();
        }
    },
);

export default SignInForm;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/SignInForm.js